import { AccountGotoAction } from '../account-router';
import { UpdatePasswordModel } from './model/update-password-model';

export class ResetPassword {
  static readonly type = '[PasswordUpdate] Reset password';
  constructor(public updatePasswordModel: UpdatePasswordModel) {}
}

export class SetPassword {
  static readonly type = '[PasswordUpdate] Set password';
  constructor(public updatePasswordModel: UpdatePasswordModel) {}
}

export class RequestPasswordUpdate {
  static readonly type = '[PasswordUpdate] Request password update';
  constructor(public email: string, public securityUpdate: boolean = false) {}
}

export class VerifyPasswordUpdate {
  static readonly type = '[PasswordUpdate] Check if password was updated';
  constructor(public timeoutInMilliseconds: number) {}
}

export class CompletePasswordUpdate {
  static readonly type = '[PasswordUpdate] Complete password update';
}

export class ResendPasswordUpdateMail {
  static readonly type = '[PasswordUpdate] Resend password update email';
}

export class CancelPasswordUpdate {
  static readonly type = '[PasswordUpdate] Cancel password update';
}

export class GotoSetPassword extends AccountGotoAction {
  static readonly type = '[PasswordUpdate] Goto set password';
}

export class GotoSetPasswordDone extends AccountGotoAction {
  static readonly type = '[PasswordUpdate] Goto set password done';
}

export class GotoResetPassword extends AccountGotoAction {
  static readonly type = '[PasswordUpdate] Goto reset password';
}

export class GotoResetPasswordDone extends AccountGotoAction {
  static readonly type = '[PasswordUpdate] Goto reset password done';
}
